import { render, staticRenderFns } from "./CostDiffHandle.vue?vue&type=template&id=86a4491c&scoped=true"
import script from "./CostDiffHandle.vue?vue&type=script&lang=js"
export * from "./CostDiffHandle.vue?vue&type=script&lang=js"
import style0 from "./CostDiffHandle.vue?vue&type=style&index=0&id=86a4491c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4491c",
  null
  
)

export default component.exports